import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import { TestTool } from "../core/debug/DataChecker/Internal/TestTool";
import { GameSetting } from "../core/setting/GameSetting";
import { GameConfig, SanGameMode } from "./config/base/GameConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { LogLevel, Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { SanSymbolData } from "./engine/Symbol/SanSymbolData";
import { SanEngineManager } from "./engine/SanEngineManager";
import { BaseModel } from "./server/base/BaseModel";
import { AssetLoader } from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import { GameFlowController } from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import { PresentationManager } from "../core/gameflow/controller/PresentationManager";
import { SanBackground } from "./modules/background/SanBackground";
import { BigWinPoster } from "./modules/poster/BigWinPoster";
import { ParticlesManager } from "./modules/particles/ParticlesManager";
import { JumpingWildController } from "./modules/jumpingWild/JumpingWildController";
import { XWaysCounter } from "./modules/countup/XWaysCounter";
import { PostCounter } from "./modules/poster/PostCounter";
import { Speedster } from "../core/debug/Speedster";
import { SanCounter } from "./modules/countup/SanCounter";
import { NolimitPlugin } from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import { UniversalPlayer } from "../core/displayobject/UniversalPlayer";
import { ResourcesGroupName } from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import { FlowState } from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import { StartPresentation } from "./presentations/reel/Normal/StartPresentation";
import { AssetsConfig } from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import { GameAssets } from "./config/texture/GameAssets";
import { OverlayAnimation } from './component/OverlayAnimation';
import { ReelStoppedPresentation } from "./presentations/reel/ReelStoppedPresentation";
import { ModeTriggerPresentation } from "./presentations/transition/ModeTriggerPresentation";
import { SetupStopPresentation } from "./presentations/reel/Setup/SetupStopPresentation"
import { ZeroBetPresentation } from "./zero/ZeroBetPresentation";
import { SplashController } from "./modules/splashScreen/SplashController";
import { FSStartPresentation } from "./presentations/reel/FS/FSStartPresentation";
import { FSBarJWStopPresentation } from "./presentations/reel/FS/FSBarJWStopPresentation";
import { StopPresentation } from "./presentations/reel/Normal/StopPresentation";
import { FSStopPresentation } from "./presentations/reel/FS/FSStopPresentation";
import { FSReelStoppedPresentation } from "./presentations/reel/FS/FSReelStoppedPresentation";
import { NormalWinPresentation } from "./presentations/features/normalwin/NormalWinPresentation";
import { BigWinPresentation } from './presentations/features/bigwin/BigWinPresentation';
import { RestorePresentation } from "./presentations/features/restore/RestorePresentation";
import { SetupResultPresentation } from "./presentations/reel/Setup/SetupResultPresentation";
import { IdlePresentation } from "./presentations/features/idle/IdlePresentation";
import { IntroPresentation } from "./presentations/features/intro/IntroPresentation";
import { Presentation } from "../core/gameflow/controller/Presentation";
// import { TestPresentation } from "./presentations/transition/TestPresentation";
import { SetupAnimationHandler } from "./modules/fs_Setup/SetupAnimationHandler";
import { FirstSetupPresentation } from "./presentations/transition/FirstSetupPresentation";
import {  BrokeTheBankPresentation } from "./presentations/features/outro/BrokeTheBankPresentation";
import { SoundManager } from "./config/sound/SoundManager";
import { SoundConfig } from "./config/sound/SoundConfig";
import { NoWinDefault } from "./config/base/NoWinDefault";
import { BorderAnim } from "./modules/poster/BorderAnim";

export class SanQuentin2 extends SlotGame {

    getNoWinGameData(): any { return NoWinDefault.NO_WIN_GAME_DATA; }

    public static model: BaseModel;
    
    public static assetLoader: AssetLoader;
    public static gameSetting: GameSetting;

    public static symbolData: SanSymbolData;
    private static gameFlowController: GameFlowController;
    private static presentationManager: PresentationManager;

    public static reelEngineManager: SanEngineManager;
    public static background: SanBackground;
    public static counter: SanCounter;

    public static overlay: OverlayAnimation;
    public static BigWinPoster: BigWinPoster;
    public static BorderFire: BorderAnim;
    public static splashController: SplashController;
    public static setupPhase: SetupAnimationHandler;

    public static particleManager: ParticlesManager;
    public static particleManagerBehind: ParticlesManager;
    
    public static jumpingWildController: JumpingWildController;
    public static xWaysCounter:XWaysCounter;

    public static postCounter:PostCounter;

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {
            
            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            GameAssets.buildAssetPaths();
            AssetsConfig.addToAssetsConfig(GameAssets.RESOURCES_GROUPS);

            SanQuentin2.assetLoader = new AssetLoader(SanQuentin2.apiPlugin, NolimitApplication.resourcePath + "/resources/");
            
            return Promise.all([fontLoader.load(), SanQuentin2.assetLoader.load(ResourcesGroupName.MAIN)]).then((values: any) => {
                
                UniversalPlayer.setLoader(SanQuentin2.assetLoader);
                
                (SanQuentin2.symbolData = new SanSymbolData(SanQuentin2.assetLoader, GameConfig.DEFAULT_SYMBOL_DIM
                   )).parseInitDataForInit(SanQuentin2.model.initData);

                SanQuentin2.presentationManager.initPresentations();

                this.createViewsAndComponents();
                return value;
            });
        });
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            
            SanQuentin2.gameSetting = GameSetting.getInstance(SanQuentin2.apiPlugin);
            SanQuentin2.model = new BaseModel(SanQuentin2.apiPlugin);
            SanQuentin2.model.logger.level = LogLevel.DEV;

            SanQuentin2.gameFlowController = new GameFlowController(SanQuentin2.apiPlugin, SanQuentin2.model);
            SanQuentin2.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            SanQuentin2.presentationManager = new PresentationManager(SanQuentin2.model, SanQuentin2.gameFlowController);

            const introPres = new IntroPresentation();
            const idlePres = new IdlePresentation();

            const normalStart = new StartPresentation();
            const fsStart = new FSStartPresentation();
            const normalStop = new StopPresentation();

            const fsStop = new FSStopPresentation();
            const barJwStop = new FSBarJWStopPresentation();
            const fsStopped = new FSReelStoppedPresentation();
            const modeChange = new ModeTriggerPresentation();

            const setupStop = new SetupStopPresentation();
            const setupResult = new SetupResultPresentation();

            const zeroBet = new ZeroBetPresentation();
            const restore = new RestorePresentation();
            
            const normalWin = new NormalWinPresentation();
            const brokeBank = new BrokeTheBankPresentation();
            const bigWin = new BigWinPresentation();

            SanQuentin2.presentationManager.addModeControllers(SanGameMode.NORMAL, new Map<FlowState, Presentation[]>([
                [FlowState.IDLE, [introPres, idlePres, restore]],
                [FlowState.BET, [normalStart]],
                [FlowState.RESULT, [normalStop, new ReelStoppedPresentation(), normalWin, bigWin]],
                [FlowState.WIN, [modeChange, brokeBank]]
            ]));

            SanQuentin2.presentationManager.addModeControllers(SanGameMode.FREESPIN_SETUP1, new Map<FlowState, Presentation[]>([
                [FlowState.IDLE, [restore, zeroBet]],
                [FlowState.BET, [ ]],
                [FlowState.RESULT, [ new FirstSetupPresentation() ]],
                [FlowState.WIN, [brokeBank]],
            ]));

            SanQuentin2.presentationManager.addModeControllers(SanGameMode.FREESPIN_SETUP2, new Map<FlowState, Presentation[]>([
                [FlowState.IDLE, [restore, zeroBet]],
                [FlowState.BET, [fsStart]],
                [FlowState.RESULT, [ setupStop, setupResult ]],
                [FlowState.WIN, []]
            ]));

            SanQuentin2.presentationManager.addModeControllers(SanGameMode.FREESPIN, new Map<FlowState, Presentation[]>([
                [FlowState.IDLE, [restore, zeroBet]],
                [FlowState.BET, [fsStart]],
                [FlowState.RESULT, [
                    barJwStop, fsStop, fsStopped,
                    normalWin, bigWin
                ]],
                [FlowState.WIN, [modeChange, brokeBank]]
            ]));
            return value;
        })
    }

    // Player presses the start button.
    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            
            SanQuentin2.gameFlowController.start();
            return value;
        });
    }

    private createViewsAndComponents() {
        
        if (GameSetting.isDevMode) {
            Logger.logDev("SymbolData: ", SanSymbolData.getAllConfigs());
            this.addLayer(new Speedster());
            this.addLayer(new TestTool(SanQuentin2.model));
            SoundManager.soundPlayer.showLogs(GameSetting.isDevMode);
        }
        SoundManager.PlayAmbience(SoundConfig.GAME_INTRO_SOUND);
        
        SanQuentin2.reelEngineManager = new SanEngineManager(
            5,
            GameConfig.REEL_ENGINE_CONFIG,
            SanQuentin2.model.initData.Reel,
            (value: number) => SanQuentin2.gameFlowController.calculatePaddingDuration(value) // ReelManager should NOT have dependencies to GameflowController.
        );

        SanQuentin2.background = new SanBackground();
            
        SanQuentin2.postCounter = new PostCounter();

        SanQuentin2.counter = new SanCounter();
        SanQuentin2.BigWinPoster = new BigWinPoster();
        SanQuentin2.BorderFire = new BorderAnim();

        SanQuentin2.splashController = new SplashController();
        SanQuentin2.setupPhase = new SetupAnimationHandler();

        SanQuentin2.particleManager = new ParticlesManager();
        SanQuentin2.particleManagerBehind = new ParticlesManager();
        SanQuentin2.xWaysCounter = new XWaysCounter();
        SanQuentin2.overlay = new OverlayAnimation();

        SanQuentin2.jumpingWildController = new JumpingWildController();
        
        this.addLayer(SanQuentin2.counter);
        this.addLayer(SanQuentin2.particleManager);
        this.addLayer(SanQuentin2.postCounter);
        this.addLayer(SanQuentin2.BigWinPoster);
        this.addLayer(SanQuentin2.particleManagerBehind);

        this.addLayer(SanQuentin2.BorderFire);
        
        this.addLayer(SanQuentin2.splashController);
        this.addLayer(SanQuentin2.overlay);
        this.addLayer(SanQuentin2.setupPhase);

        this.addLayer(SanQuentin2.xWaysCounter);
        this.addLayer(SanQuentin2.jumpingWildController);
        this.addLayer(SanQuentin2.reelEngineManager);
        this.addLayer(SanQuentin2.background);

        SanQuentin2.background.parent.pivot.set(360,360);
        SanQuentin2.background.parent.position.set(360,360);
    }

    private addLayer(layer: any, order: number = 0): any {
        NolimitApplication.addLayerAt(layer.constructor.name, layer, order);
        return layer;
    }
}